<template>
  <div class="motorbike-damage">
    <svg
      class="clickable"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="250px"
      height="409px"
      viewBox="585 250 125 50"
      xml:space="preserve"
      style="max-height:500px;"
    >
      <defs>
        <radialGradient
          id="radial-gradient"
          cx="273.43"
          cy="496.4"
          fx="273.43"
          fy="496.4"
          r="42.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".8" stop-color="#515151" />
          <stop offset=".85" stop-color="#4c4c4c" />
          <stop offset=".89" stop-color="#403f40" />
          <stop offset=".94" stop-color="#2b2a2b" />
          <stop offset=".94" stop-color="#2a292a" />
          <stop offset=".95" stop-color="#302f30" />
          <stop offset=".97" stop-color="#424142" />
          <stop offset="1" stop-color="#5f5f5f" />
          <stop offset="1" stop-color="#676767" />
        </radialGradient>
        <linearGradient
          id="linear-gradient"
          x1="281.86"
          y1="486.57"
          x2="283.42"
          y2="488.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#0c0d0d" />
          <stop offset="1" stop-color="#dedede" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="277.37"
          y1="483.53"
          x2="278.93"
          y2="485.1"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-3"
          x1="272.03"
          y1="482.58"
          x2="273.6"
          y2="484.15"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-4"
          x1="266.77"
          y1="483.89"
          x2="268.33"
          y2="485.45"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-5"
          x1="262.49"
          y1="487.22"
          x2="264.06"
          y2="488.78"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-6"
          x1="259.94"
          y1="492"
          x2="261.51"
          y2="493.57"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-7"
          x1="259.55"
          y1="497.41"
          x2="261.12"
          y2="498.97"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-8"
          x1="261.4"
          y1="502.51"
          x2="262.97"
          y2="504.07"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-9"
          x1="265.16"
          y1="506.41"
          x2="266.73"
          y2="507.98"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-10"
          x1="270.18"
          y1="508.45"
          x2="271.75"
          y2="510.01"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-11"
          x1="275.6"
          y1="508.27"
          x2="277.17"
          y2="509.83"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-12"
          x1="280.48"
          y1="505.9"
          x2="282.04"
          y2="507.46"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-13"
          x1="283.97"
          y1="501.75"
          x2="285.53"
          y2="503.32"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-14"
          x1="285.47"
          y1="496.54"
          x2="287.04"
          y2="498.11"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-15"
          x1="284.72"
          y1="491.17"
          x2="286.29"
          y2="492.74"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-16"
          x1="280.62"
          y1="469.27"
          x2="285.48"
          y2="471.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#808181" />
          <stop offset=".17" stop-color="#e4e4e3" />
          <stop offset=".23" stop-color="#d0d0cf" />
          <stop offset=".38" stop-color="#a7a7a7" />
          <stop offset=".45" stop-color="#989898" />
          <stop offset=".51" stop-color="#9e9e9e" />
          <stop offset=".59" stop-color="#b0b0b0" />
          <stop offset=".68" stop-color="#cdcdcd" />
          <stop offset=".76" stop-color="#f0f0f0" />
          <stop offset="1" stop-color="#989898" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-17"
          x1="359.63"
          y1="257.2"
          x2="365.32"
          y2="257.2"
          gradientTransform="translate(-86.38 231.64)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#010101" />
          <stop offset=".02" stop-color="#050505" />
          <stop offset=".22" stop-color="#272727" />
          <stop offset=".33" stop-color="#343434" />
          <stop offset=".42" stop-color="#373737" />
          <stop offset=".51" stop-color="#434343" />
          <stop offset=".59" stop-color="#565656" />
          <stop offset=".67" stop-color="#707171" />
          <stop offset=".71" stop-color="#808181" />
          <stop offset="1" stop-color="#1b1b1b" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-18"
          x1="216.37"
          y1="466.57"
          x2="216.37"
          y2="454.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#808181" />
          <stop offset=".17" stop-color="#e4e4e3" />
          <stop offset=".5" stop-color="#9c9c9c" />
          <stop offset=".69" stop-color="#767676" />
          <stop offset=".72" stop-color="#7c7c7c" />
          <stop offset=".76" stop-color="#8e8e8e" />
          <stop offset=".81" stop-color="#ababab" />
          <stop offset=".87" stop-color="#d3d3d3" />
          <stop offset=".9" stop-color="#f0f0f0" />
          <stop offset="1" stop-color="#989898" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-19"
          x1="3135.65"
          y1="-1226.12"
          x2="3135.65"
          y2="-1236.77"
          gradientTransform="translate(3355.78 -766.13) rotate(-180)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#1c1c1c" />
          <stop offset="0" stop-color="#222" />
          <stop offset=".04" stop-color="#555" />
          <stop offset=".07" stop-color="#838383" />
          <stop offset=".1" stop-color="#a9a9a9" />
          <stop offset=".13" stop-color="#c8c8c8" />
          <stop offset=".16" stop-color="#e0e0e0" />
          <stop offset=".19" stop-color="#f1f1f1" />
          <stop offset=".23" stop-color="#fbfbfb" />
          <stop offset=".27" stop-color="#fff" />
          <stop offset=".29" stop-color="#d5d5d5" />
          <stop offset=".31" stop-color="#a8a8a9" />
          <stop offset=".34" stop-color="#818181" />
          <stop offset=".36" stop-color="#606060" />
          <stop offset=".39" stop-color="#444445" />
          <stop offset=".41" stop-color="#303030" />
          <stop offset=".45" stop-color="#212122" />
          <stop offset=".48" stop-color="#181819" />
          <stop offset=".54" stop-color="#161617" />
          <stop offset=".57" stop-color="#1a1a1b" />
          <stop offset=".6" stop-color="#29292a" />
          <stop offset=".63" stop-color="#404041" />
          <stop offset=".67" stop-color="#626262" />
          <stop offset=".71" stop-color="#8c8c8d" />
          <stop offset=".74" stop-color="#c1c1c1" />
          <stop offset=".78" stop-color="#fdfdfd" />
          <stop offset=".78" stop-color="#fff" />
          <stop offset=".84" stop-color="#fcfcfc" />
          <stop offset=".87" stop-color="#f4f4f4" />
          <stop offset=".89" stop-color="#e5e5e5" />
          <stop offset=".91" stop-color="#d1d1d1" />
          <stop offset=".94" stop-color="#b7b7b7" />
          <stop offset=".95" stop-color="#979797" />
          <stop offset=".97" stop-color="#717171" />
          <stop offset=".99" stop-color="#464646" />
          <stop offset="1" stop-color="#242424" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-20"
          x1="407.74"
          y1="400.88"
          x2="417.67"
          y2="394.67"
          gradientTransform="translate(250.65 -152.05) rotate(29.63)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#1c1c1c" />
          <stop offset=".02" stop-color="#313131" />
          <stop offset=".07" stop-color="#6f6f6f" />
          <stop offset=".13" stop-color="#a2a2a2" />
          <stop offset=".18" stop-color="#cacaca" />
          <stop offset=".22" stop-color="#e7e7e7" />
          <stop offset=".26" stop-color="#f8f8f8" />
          <stop offset=".29" stop-color="#fff" />
          <stop offset=".31" stop-color="#d5d5d5" />
          <stop offset=".33" stop-color="#a8a8a9" />
          <stop offset=".35" stop-color="#818181" />
          <stop offset=".37" stop-color="#606060" />
          <stop offset=".39" stop-color="#444445" />
          <stop offset=".42" stop-color="#303030" />
          <stop offset=".45" stop-color="#212122" />
          <stop offset=".49" stop-color="#181819" />
          <stop offset=".54" stop-color="#161617" />
          <stop offset=".57" stop-color="#1a1a1b" />
          <stop offset=".61" stop-color="#272728" />
          <stop offset=".64" stop-color="#3c3c3d" />
          <stop offset=".68" stop-color="#5a5a5b" />
          <stop offset=".71" stop-color="#818182" />
          <stop offset=".75" stop-color="#b0b0b1" />
          <stop offset=".78" stop-color="#e7e7e8" />
          <stop offset=".8" stop-color="#fff" />
          <stop offset=".82" stop-color="#f1f1f1" />
          <stop offset=".86" stop-color="#cdcdcd" />
          <stop offset=".91" stop-color="#939393" />
          <stop offset=".98" stop-color="#444" />
          <stop offset="1" stop-color="#242424" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-21"
          x1="355.66"
          y1="458.69"
          x2="355.66"
          y2="452.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#808181" />
          <stop offset=".17" stop-color="#e4e4e3" />
          <stop offset=".18" stop-color="#e1e1e0" />
          <stop offset=".31" stop-color="#9f9f9f" />
          <stop offset=".4" stop-color="#767676" />
          <stop offset=".45" stop-color="#676767" />
          <stop offset=".49" stop-color="#6d6d6d" />
          <stop offset=".55" stop-color="#7f7f7f" />
          <stop offset=".62" stop-color="#9c9c9c" />
          <stop offset=".7" stop-color="#c4c4c4" />
          <stop offset=".76" stop-color="#f0f0f0" />
          <stop offset="1" stop-color="#989898" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-22"
          x1="352.81"
          y1="459.19"
          x2="352.81"
          y2="451.64"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#808181" />
          <stop offset=".17" stop-color="#e4e4e3" />
          <stop offset=".19" stop-color="#d7d7d6" />
          <stop offset=".28" stop-color="#7c7c7c" />
          <stop offset=".36" stop-color="#393939" />
          <stop offset=".42" stop-color="#101010" />
          <stop offset=".45" stop-color="#010101" />
          <stop offset=".48" stop-color="#070707" />
          <stop offset=".52" stop-color="#191919" />
          <stop offset=".57" stop-color="#363636" />
          <stop offset=".62" stop-color="#5f5f5f" />
          <stop offset=".68" stop-color="#939393" />
          <stop offset=".74" stop-color="#d2d2d2" />
          <stop offset=".76" stop-color="#f0f0f0" />
          <stop offset="1" stop-color="#989898" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-23"
          x1="420.97"
          y1="405.27"
          x2="420.97"
          y2="401.08"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-24"
          x1="420.46"
          y1="405.62"
          x2="420.46"
          y2="400.72"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-25"
          x1="389.73"
          y1="461.23"
          x2="389.73"
          y2="451.77"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-26"
          x1="377.04"
          y1="454.99"
          x2="377.04"
          y2="453.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#161617" />
          <stop offset=".09" stop-color="#1a1a1b" />
          <stop offset=".2" stop-color="#29292a" />
          <stop offset=".32" stop-color="#404041" />
          <stop offset=".45" stop-color="#626262" />
          <stop offset=".58" stop-color="#8c8c8d" />
          <stop offset=".71" stop-color="silver" />
          <stop offset=".77" stop-color="#d9d9d9" />
          <stop offset=".84" stop-color="#d6d6d6" />
          <stop offset=".88" stop-color="#cfcfcf" />
          <stop offset=".91" stop-color="#c2c2c2" />
          <stop offset=".93" stop-color="#b0b0b0" />
          <stop offset=".95" stop-color="#989898" />
          <stop offset=".96" stop-color="#7b7b7b" />
          <stop offset=".98" stop-color="#595959" />
          <stop offset="1" stop-color="#323232" />
          <stop offset="1" stop-color="#242424" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-27"
          x1="377.04"
          y1="456.75"
          x2="377.04"
          y2="455.74"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-28"
          x1="377.04"
          y1="447.94"
          x2="377.04"
          y2="447.03"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-29"
          x1="377.04"
          y1="449.7"
          x2="377.04"
          y2="448.7"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-30"
          x1="377.04"
          y1="459.19"
          x2="377.04"
          y2="457.51"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-31"
          x1="377.04"
          y1="453.22"
          x2="377.04"
          y2="452.22"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-32"
          x1="377.04"
          y1="451.46"
          x2="377.04"
          y2="450.46"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-33"
          x1="377.04"
          y1="472.59"
          x2="377.04"
          y2="471.48"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-34"
          x1="377.04"
          y1="470.63"
          x2="377.04"
          y2="469.52"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-35"
          x1="377.04"
          y1="480.33"
          x2="377.04"
          y2="479.32"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-36"
          x1="377.04"
          y1="478.48"
          x2="377.04"
          y2="477.36"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-37"
          x1="377.04"
          y1="468.67"
          x2="377.04"
          y2="466.8"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-38"
          x1="377.04"
          y1="474.55"
          x2="377.04"
          y2="473.44"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-39"
          x1="377.04"
          y1="476.52"
          x2="377.04"
          y2="475.4"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-40"
          x1="377.04"
          y1="466.27"
          x2="377.04"
          y2="465.26"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-41"
          x1="377.04"
          y1="460.98"
          x2="377.04"
          y2="459.98"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-42"
          x1="377.04"
          y1="464.5"
          x2="377.04"
          y2="463.5"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-43"
          x1="377.04"
          y1="462.74"
          x2="377.04"
          y2="461.74"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-44"
          x1="372.53"
          y1="471.02"
          x2="373.45"
          y2="471.95"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-45"
          x1="372.53"
          y1="474.77"
          x2="373.45"
          y2="475.7"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-46"
          x1="379.57"
          y1="471.02"
          x2="380.49"
          y2="471.95"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-47"
          x1="379.57"
          y1="474.77"
          x2="380.49"
          y2="475.7"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-48"
          x1="376.51"
          y1="476.14"
          x2="376.51"
          y2="470.58"
          gradientTransform="translate(849.87 96.85) rotate(90)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#dedede" />
          <stop offset=".28" stop-color="#dbdbdb" />
          <stop offset=".48" stop-color="#d1d1d1" />
          <stop offset=".65" stop-color="#c2c2c2" />
          <stop offset=".81" stop-color="#ababab" />
          <stop offset=".96" stop-color="#8f8f8f" />
          <stop offset="1" stop-color="#878787" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-49"
          x1="367.63"
          y1="443.51"
          x2="370.6"
          y2="443.51"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-50"
          x1="369.11"
          y1="447.03"
          x2="369.11"
          y2="443.28"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".02" stop-color="#161617" />
          <stop offset=".1" stop-color="#1a1a1b" />
          <stop offset=".19" stop-color="#29292a" />
          <stop offset=".29" stop-color="#404041" />
          <stop offset=".39" stop-color="#626262" />
          <stop offset=".5" stop-color="#8c8c8d" />
          <stop offset=".61" stop-color="#c1c1c1" />
          <stop offset=".72" stop-color="#fdfdfd" />
          <stop offset=".73" stop-color="#fff" />
          <stop offset=".79" stop-color="#fcfcfc" />
          <stop offset=".83" stop-color="#f4f4f4" />
          <stop offset=".86" stop-color="#e5e5e5" />
          <stop offset=".89" stop-color="#d1d1d1" />
          <stop offset=".92" stop-color="#b7b7b7" />
          <stop offset=".94" stop-color="#979797" />
          <stop offset=".96" stop-color="#717171" />
          <stop offset=".99" stop-color="#464646" />
          <stop offset="1" stop-color="#242424" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-51"
          x1="375.03"
          y1="444.15"
          x2="376.74"
          y2="444.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#1c1c1c" />
          <stop offset=".02" stop-color="#454545" />
          <stop offset=".04" stop-color="#727171" />
          <stop offset=".06" stop-color="#989797" />
          <stop offset=".08" stop-color="#b7b6b6" />
          <stop offset=".11" stop-color="#cfcece" />
          <stop offset=".13" stop-color="#e0dfdf" />
          <stop offset=".16" stop-color="#eae9e9" />
          <stop offset=".19" stop-color="#eeeded" />
          <stop offset=".22" stop-color="#bdbdbd" />
          <stop offset=".25" stop-color="#919191" />
          <stop offset=".29" stop-color="#6b6b6b" />
          <stop offset=".32" stop-color="#4c4c4c" />
          <stop offset=".36" stop-color="#343435" />
          <stop offset=".4" stop-color="#232324" />
          <stop offset=".44" stop-color="#19191a" />
          <stop offset=".49" stop-color="#161617" />
          <stop offset=".58" stop-color="#181819" />
          <stop offset=".63" stop-color="#202021" />
          <stop offset=".67" stop-color="#2d2d2e" />
          <stop offset=".7" stop-color="#414141" />
          <stop offset=".73" stop-color="#5a5a5a" />
          <stop offset=".76" stop-color="#787879" />
          <stop offset=".79" stop-color="#9d9d9d" />
          <stop offset=".81" stop-color="#c7c7c8" />
          <stop offset=".83" stop-color="#f6f6f6" />
          <stop offset=".83" stop-color="#fff" />
          <stop offset=".87" stop-color="#fcfcfc" />
          <stop offset=".9" stop-color="#f4f4f4" />
          <stop offset=".92" stop-color="#e5e5e5" />
          <stop offset=".93" stop-color="#d1d1d1" />
          <stop offset=".95" stop-color="#b7b7b7" />
          <stop offset=".96" stop-color="#979797" />
          <stop offset=".98" stop-color="#717171" />
          <stop offset=".99" stop-color="#464646" />
          <stop offset="1" stop-color="#242424" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-52"
          x1="383.48"
          y1="443.51"
          x2="386.45"
          y2="443.51"
          gradientTransform="translate(769.94 887.01) rotate(180)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-53"
          x1="384.97"
          x2="384.97"
          gradientTransform="translate(769.94 890.31) rotate(-180)"
          xlink:href="#linear-gradient-50"
        />
        <linearGradient
          id="linear-gradient-54"
          x1="377.34"
          x2="379.05"
          gradientTransform="translate(756.39 888.29) rotate(-180)"
          xlink:href="#linear-gradient-51"
        />
        <linearGradient
          id="linear-gradient-55"
          x1="366.08"
          y1="500.96"
          x2="366.08"
          y2="478.99"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#1c1c1c" />
          <stop offset=".03" stop-color="#454545" />
          <stop offset=".06" stop-color="#727171" />
          <stop offset=".09" stop-color="#989797" />
          <stop offset=".12" stop-color="#b7b6b6" />
          <stop offset=".15" stop-color="#cfcece" />
          <stop offset=".19" stop-color="#e0dfdf" />
          <stop offset=".23" stop-color="#eae9e9" />
          <stop offset=".27" stop-color="#eeeded" />
          <stop offset=".31" stop-color="#bdbdbd" />
          <stop offset=".35" stop-color="#919191" />
          <stop offset=".39" stop-color="#6b6b6b" />
          <stop offset=".43" stop-color="#4c4c4c" />
          <stop offset=".48" stop-color="#343435" />
          <stop offset=".52" stop-color="#232324" />
          <stop offset=".57" stop-color="#19191a" />
          <stop offset=".63" stop-color="#161617" />
          <stop offset=".66" stop-color="#1a1a1b" />
          <stop offset=".69" stop-color="#29292a" />
          <stop offset=".72" stop-color="#404041" />
          <stop offset=".76" stop-color="#626262" />
          <stop offset=".8" stop-color="#8c8c8d" />
          <stop offset=".84" stop-color="#c1c1c1" />
          <stop offset=".87" stop-color="#fdfdfd" />
          <stop offset=".88" stop-color="#fff" />
          <stop offset=".91" stop-color="#fcfcfc" />
          <stop offset=".92" stop-color="#f4f4f4" />
          <stop offset=".94" stop-color="#e5e5e5" />
          <stop offset=".95" stop-color="#d1d1d1" />
          <stop offset=".96" stop-color="#b7b7b7" />
          <stop offset=".97" stop-color="#979797" />
          <stop offset=".98" stop-color="#717171" />
          <stop offset=".99" stop-color="#464646" />
          <stop offset="1" stop-color="#242424" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-56"
          x1="344.47"
          y1="491.04"
          x2="346.67"
          y2="493.25"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-57"
          x1="345.57"
          y1="493.33"
          x2="345.57"
          y2="490.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#242424" />
          <stop offset=".13" stop-color="#4b4b4b" />
          <stop offset=".47" stop-color="#ababab" />
          <stop offset=".7" stop-color="#e7e7e7" />
          <stop offset=".81" stop-color="#fff" />
          <stop offset=".88" stop-color="#a9a9a9" />
          <stop offset="1" stop-color="#161617" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-58"
          x1="365.69"
          y1="496.99"
          x2="367.9"
          y2="499.19"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-59"
          x1="366.8"
          y1="499.27"
          x2="366.8"
          y2="496.91"
          xlink:href="#linear-gradient-57"
        />
        <linearGradient
          id="linear-gradient-60"
          x1="344.47"
          y1="486.7"
          x2="346.67"
          y2="488.91"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-61"
          y1="488.99"
          y2="486.63"
          xlink:href="#linear-gradient-57"
        />
        <linearGradient
          id="linear-gradient-62"
          x1="366.8"
          y1="489.26"
          x2="366.8"
          y2="481.77"
          gradientTransform="translate(121.93 -71.54) rotate(13.34)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#242424" />
          <stop offset=".05" stop-color="#4b4b4b" />
          <stop offset=".17" stop-color="#ababab" />
          <stop offset=".26" stop-color="#e7e7e7" />
          <stop offset=".3" stop-color="#fff" />
          <stop offset=".33" stop-color="#e7e7e7" />
          <stop offset=".39" stop-color="#b7b7b7" />
          <stop offset=".46" stop-color="#8b8b8c" />
          <stop offset=".54" stop-color="#676768" />
          <stop offset=".61" stop-color="#49494a" />
          <stop offset=".69" stop-color="#323233" />
          <stop offset=".78" stop-color="#222223" />
          <stop offset=".87" stop-color="#19191a" />
          <stop offset="1" stop-color="#161617" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-63"
          x1="373.51"
          y1="412.55"
          x2="385.22"
          y2="411.11"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-64"
          x1="217.4"
          y1="510.44"
          x2="217.4"
          y2="504.76"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-65"
          x1="274.73"
          y1="514.68"
          x2="274.73"
          y2="500.51"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-66"
          x1="399.51"
          y1="377.35"
          x2="399.51"
          y2="362.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#d6d7d7" />
          <stop offset="0" stop-color="#c8c9c9" />
          <stop offset=".05" stop-color="#929393" />
          <stop offset=".09" stop-color="#666667" />
          <stop offset=".13" stop-color="#434344" />
          <stop offset=".17" stop-color="#2a2a2b" />
          <stop offset=".2" stop-color="#1b1b1c" />
          <stop offset=".22" stop-color="#161617" />
          <stop offset=".25" stop-color="#242425" />
          <stop offset=".31" stop-color="#4b4b4c" />
          <stop offset=".38" stop-color="#8a8a8b" />
          <stop offset=".47" stop-color="#e0e0e0" />
          <stop offset=".5" stop-color="#fff" />
          <stop offset=".59" stop-color="#f9f9f9" />
          <stop offset=".69" stop-color="#ebebea" />
          <stop offset=".81" stop-color="#d2d2d2" />
          <stop offset=".94" stop-color="#b0b0af" />
          <stop offset="1" stop-color="#9d9d9c" />
        </linearGradient>
        <radialGradient
          id="radial-gradient-2"
          cx="461.06"
          cy="496.4"
          fx="461.06"
          fy="496.4"
          r="42.89"
          xlink:href="#radial-gradient"
        />
        <linearGradient
          id="linear-gradient-67"
          x1="466.64"
          y1="489.82"
          x2="467.69"
          y2="490.87"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-68"
          x1="463.64"
          y1="487.78"
          x2="464.69"
          y2="488.83"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-69"
          x1="460.06"
          y1="487.15"
          x2="461.11"
          y2="488.19"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-70"
          x1="456.54"
          y1="488.02"
          x2="457.59"
          y2="489.07"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-71"
          x1="453.68"
          y1="490.25"
          x2="454.72"
          y2="491.3"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-72"
          x1="451.97"
          y1="493.45"
          x2="453.01"
          y2="494.5"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-73"
          x1="451.71"
          y1="497.07"
          x2="452.76"
          y2="498.12"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-74"
          x1="452.94"
          y1="500.49"
          x2="453.99"
          y2="501.54"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-75"
          x1="455.46"
          y1="503.1"
          x2="456.51"
          y2="504.15"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-76"
          x1="458.83"
          y1="504.47"
          x2="459.87"
          y2="505.52"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-77"
          x1="462.45"
          y1="504.35"
          x2="463.5"
          y2="505.39"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-78"
          x1="465.72"
          y1="502.76"
          x2="466.77"
          y2="503.81"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-79"
          x1="468.06"
          y1="499.98"
          x2="469.11"
          y2="501.03"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-80"
          x1="469.06"
          y1="496.49"
          x2="470.11"
          y2="497.54"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-81"
          x1="468.56"
          y1="492.9"
          x2="469.61"
          y2="493.95"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-82"
          x1="438.25"
          y1="460.3"
          x2="443.73"
          y2="457.38"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-83"
          x1="421.15"
          y1="427.87"
          x2="426.52"
          y2="425.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#808181" />
          <stop offset=".17" stop-color="#e4e4e3" />
          <stop offset=".22" stop-color="#c7c7c6" />
          <stop offset=".33" stop-color="#858585" />
          <stop offset=".41" stop-color="#5c5c5c" />
          <stop offset=".45" stop-color="#4d4d4d" />
          <stop offset=".49" stop-color="#535353" />
          <stop offset=".54" stop-color="#656565" />
          <stop offset=".6" stop-color="#828282" />
          <stop offset=".67" stop-color="#ababab" />
          <stop offset=".74" stop-color="#dedede" />
          <stop offset=".76" stop-color="#f0f0f0" />
          <stop offset="1" stop-color="#989898" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-84"
          x1="420.37"
          y1="436.71"
          x2="420.37"
          y2="426.06"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-85"
          x1="434.24"
          y1="405.31"
          x2="434.24"
          y2="398.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#d6d7d7" />
          <stop offset=".08" stop-color="#d1d2d2" />
          <stop offset=".15" stop-color="#c5c6c6" />
          <stop offset=".23" stop-color="#b0b1b1" />
          <stop offset=".31" stop-color="#949495" />
          <stop offset=".39" stop-color="#6e6f6f" />
          <stop offset=".47" stop-color="#414242" />
          <stop offset=".54" stop-color="#161617" />
          <stop offset=".57" stop-color="#1a1a1b" />
          <stop offset=".61" stop-color="#272728" />
          <stop offset=".64" stop-color="#3c3c3d" />
          <stop offset=".68" stop-color="#5a5a5b" />
          <stop offset=".71" stop-color="#818182" />
          <stop offset=".75" stop-color="#b0b0b1" />
          <stop offset=".78" stop-color="#e7e7e8" />
          <stop offset=".8" stop-color="#fff" />
          <stop offset=".83" stop-color="#fbfbfb" />
          <stop offset=".86" stop-color="#f1f1f1" />
          <stop offset=".89" stop-color="#e1e1e1" />
          <stop offset=".91" stop-color="#c9c9c9" />
          <stop offset=".93" stop-color="#aaa" />
          <stop offset=".96" stop-color="#858585" />
          <stop offset=".98" stop-color="#585858" />
          <stop offset="1" stop-color="#262626" />
          <stop offset="1" stop-color="#242424" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-86"
          x1="428.99"
          y1="423"
          x2="428.99"
          y2="397.64"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-87"
          x1="224.55"
          y1="288.83"
          x2="224.55"
          y2="283.15"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-88"
          x1="608.04"
          y1="290.51"
          x2="608.04"
          y2="284.82"
          gradientTransform="translate(-371.45 -1.67) scale(1.2 1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-89"
          x1="281.87"
          y1="293.07"
          x2="281.87"
          y2="278.91"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-90"
          x1="209.18"
          y1="275.51"
          x2="209.18"
          y2="263.92"
          xlink:href="#linear-gradient-18"
        />
        <linearGradient
          id="linear-gradient-91"
          x1="1310.1"
          y1="-2843.41"
          x2="1310.1"
          y2="-2845.64"
          gradientTransform="translate(-1095.93 3124.02)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-92"
          x1="3142.72"
          y1="-1045.63"
          x2="3142.72"
          y2="-1056.28"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-93"
          x1="3342.63"
          y1="-2843.41"
          x2="3342.63"
          y2="-2845.64"
          gradientTransform="translate(-3128.46 -2584.59) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-94"
          x1="3142.72"
          y1="986.9"
          x2="3142.72"
          y2="976.25"
          gradientTransform="translate(3355.78 -726.97) rotate(-180) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-95"
          x1="372.95"
          y1="269.72"
          x2="384.06"
          y2="269.72"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#878787" />
          <stop offset=".04" stop-color="#8f8f8f" />
          <stop offset=".19" stop-color="#ababab" />
          <stop offset=".35" stop-color="#c2c2c2" />
          <stop offset=".52" stop-color="#d1d1d1" />
          <stop offset=".72" stop-color="#dbdbdb" />
          <stop offset="1" stop-color="#dedede" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-96"
          x1="266.95"
          y1="269.72"
          x2="343.48"
          y2="269.72"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#fff" />
          <stop offset=".02" stop-color="#e1e0e0" />
          <stop offset=".05" stop-color="#cac9c9" />
          <stop offset=".07" stop-color="#bcbbbb" />
          <stop offset=".09" stop-color="#b8b7b7" />
          <stop offset=".28" stop-color="#b6b5b5" />
          <stop offset=".34" stop-color="#afaeae" />
          <stop offset=".39" stop-color="#a3a3a2" />
          <stop offset=".41" stop-color="#9b9b9a" />
          <stop offset=".52" stop-color="#9b9b9a" />
          <stop offset=".54" stop-color="#a3a3a2" />
          <stop offset=".6" stop-color="#afaeae" />
          <stop offset=".68" stop-color="#b6b5b5" />
          <stop offset=".89" stop-color="#b8b7b7" />
          <stop offset=".92" stop-color="#c1c0c0" />
          <stop offset=".96" stop-color="#dbdada" />
          <stop offset=".98" stop-color="#eeeded" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-97"
          x1="265.39"
          x2="341.92"
          xlink:href="#linear-gradient-96"
        />
        <linearGradient
          id="linear-gradient-98"
          x1="1320.29"
          y1="-2595.64"
          x2="1320.29"
          y2="-2599.94"
          gradientTransform="translate(-859.38 2867.1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-99"
          x1="1137.47"
          y1="-2634.2"
          x2="1137.47"
          y2="-2639.62"
          gradientTransform="translate(-676.57 2891.57)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-100"
          x1="1133.37"
          y1="-2644.99"
          x2="1139.4"
          y2="-2644.99"
          gradientTransform="translate(3096.63 1392.83) rotate(-89.97)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-101"
          x1="1163.31"
          y1="-2634.2"
          x2="1163.31"
          y2="-2639.62"
          gradientTransform="translate(-702.41 2921.31)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-102"
          x1="1159.21"
          y1="-2645.01"
          x2="1165.24"
          y2="-2645.01"
          gradientTransform="translate(3096.63 1448.41) rotate(-89.97)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-103"
          x1="428.99"
          y1="282.39"
          x2="428.99"
          y2="257.03"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-104"
          x1="434.99"
          y1="280.62"
          x2="434.99"
          y2="258.81"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-105"
          x1="1119.14"
          y1="626.5"
          x2="1119.14"
          y2="624.27"
          gradientTransform="translate(-699.84 914.03) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-106"
          x1="-327.19"
          y1="-1239.98"
          x2="-327.19"
          y2="-1250.63"
          gradientTransform="translate(747.61 -947.95) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-107"
          x1="420.87"
          y1="283.35"
          x2="420.87"
          y2="279.16"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-108"
          x1="420.36"
          y1="283.71"
          x2="420.36"
          y2="278.8"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-109"
          x1="3151.67"
          y1="626.5"
          x2="3151.67"
          y2="624.27"
          gradientTransform="translate(-2732.37 -374.6)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-110"
          x1="-327.19"
          y1="792.55"
          x2="-327.19"
          y2="781.9"
          gradientTransform="translate(747.61 -545.15)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-111"
          x1="420.87"
          y1="303.4"
          x2="420.87"
          y2="299.21"
          gradientTransform="translate(0 -43.12)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-112"
          x1="420.36"
          y1="303.76"
          x2="420.36"
          y2="298.85"
          gradientTransform="translate(0 -43.12)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-113"
          x1="991.29"
          y1="-2427.92"
          x2="995.3"
          y2="-2427.92"
          gradientTransform="translate(-601.66 -2113.06) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".03" stop-color="#1b1b1b" />
          <stop offset=".09" stop-color="#212121" />
          <stop offset=".17" stop-color="#333" />
          <stop offset=".26" stop-color="#515151" />
          <stop offset=".46" stop-color="#141414" />
          <stop offset=".47" stop-color="#101010" />
          <stop offset=".63" stop-color="#343434" />
          <stop offset=".77" stop-color="#515151" />
          <stop offset=".87" stop-color="#343434" />
          <stop offset=".95" stop-color="#1b1b1b" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-114"
          x1="988.6"
          y1="-2418.7"
          x2="997.99"
          y2="-2418.7"
          gradientTransform="translate(576.79 -2301.89) rotate(26.3) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".03" stop-color="#1b1b1b" />
          <stop offset=".05" stop-color="#212121" />
          <stop offset=".08" stop-color="#333" />
          <stop offset=".12" stop-color="#525252" />
          <stop offset=".16" stop-color="#7c7c7c" />
          <stop offset=".2" stop-color="#b2b2b2" />
          <stop offset=".25" stop-color="#f2f2f2" />
          <stop offset=".26" stop-color="#fff" />
          <stop offset=".31" stop-color="#c1c1c1" />
          <stop offset=".45" stop-color="#282828" />
          <stop offset=".47" stop-color="#101010" />
          <stop offset=".5" stop-color="#252525" />
          <stop offset=".63" stop-color="#999" />
          <stop offset=".72" stop-color="#e2e2e2" />
          <stop offset=".77" stop-color="#fff" />
          <stop offset=".8" stop-color="#e2e2e2" />
          <stop offset=".86" stop-color="#979797" />
          <stop offset=".95" stop-color="#222" />
          <stop offset=".95" stop-color="#1b1b1b" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-115"
          x1="990.89"
          y1="-2438.61"
          x2="995.7"
          y2="-2438.61"
          gradientTransform="translate(-606.4 -2114.16) scale(1 -1)"
          xlink:href="#linear-gradient-113"
        />
        <linearGradient
          id="linear-gradient-116"
          x1="400.18"
          y1="-1812.02"
          x2="400.18"
          y2="-1826.42"
          gradientTransform="translate(0 -1501.4) scale(1 -1)"
          xlink:href="#linear-gradient-66"
        />
        <linearGradient
          id="linear-gradient-117"
          x1="87.17"
          y1="-598.25"
          x2="91.18"
          y2="-598.25"
          gradientTransform="translate(302.51 822.88)"
          xlink:href="#linear-gradient-113"
        />
        <linearGradient
          id="linear-gradient-118"
          x1="84.48"
          y1="-589.04"
          x2="93.87"
          y2="-589.04"
          gradientTransform="translate(576.79 800.49) rotate(-26.3)"
          xlink:href="#linear-gradient-114"
        />
        <linearGradient
          id="linear-gradient-119"
          x1="86.77"
          y1="-608.94"
          x2="91.58"
          y2="-608.94"
          gradientTransform="translate(297.77 823.99)"
          xlink:href="#linear-gradient-113"
        />
        <linearGradient
          id="linear-gradient-120"
          x1="400.18"
          y1="228.8"
          x2="400.18"
          y2="214.4"
          xlink:href="#linear-gradient-66"
        />
        <radialGradient
          id="radial-gradient-3"
          cx="3104.75"
          cy="911.42"
          fx="3104.75"
          fy="911.42"
          r="7.21"
          gradientTransform="translate(1813.01 -2647.59) rotate(99.27)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".77" stop-color="#a8a8a8" />
          <stop offset=".83" stop-color="#a9a9a9" />
          <stop offset=".85" stop-color="#b0b0b0" />
          <stop offset=".87" stop-color="#bcbbbb" />
          <stop offset=".88" stop-color="#cbcaca" />
          <stop offset=".9" stop-color="#989898" />
          <stop offset=".9" stop-color="#949494" />
          <stop offset=".91" stop-color="#7b7b7b" />
          <stop offset=".93" stop-color="#6d6d6c" />
          <stop offset=".93" stop-color="#686867" />
          <stop offset=".98" stop-color="#474747" />
          <stop offset="1" stop-color="#3b3b3b" />
        </radialGradient>
        <linearGradient
          id="linear-gradient-121"
          x1="3100.54"
          y1="907.2"
          x2="3108.99"
          y2="915.64"
          gradientTransform="translate(1324.58 -2835.06) rotate(90)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".02" stop-color="#4d4d4d" />
          <stop offset=".12" stop-color="#585858" />
          <stop offset=".72" stop-color="#959595" />
          <stop offset="1" stop-color="#adadad" />
        </linearGradient>
        <radialGradient
          id="radial-gradient-4"
          cx="3103.27"
          cy="911.42"
          fx="3103.27"
          fy="911.42"
          r=".3"
          gradientTransform="translate(1324.58 -2835.06) rotate(90)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#878787" />
          <stop offset=".16" stop-color="gray" />
          <stop offset=".38" stop-color="#6d6d6c" />
          <stop offset=".49" stop-color="#626261" />
          <stop offset=".63" stop-color="#515150" />
          <stop offset=".89" stop-color="#252626" />
          <stop offset=".92" stop-color="#1f2121" />
        </radialGradient>
        <radialGradient
          id="radial-gradient-5"
          cx="2988.57"
          fx="2988.57"
          r=".3"
          gradientTransform="translate(1324.58 -2717.42) rotate(90)"
          xlink:href="#radial-gradient-4"
        />
        <radialGradient
          id="radial-gradient-6"
          cx="3104.82"
          cy="916.37"
          fx="3104.82"
          fy="916.37"
          r=".69"
          gradientTransform="translate(1324.58 -2835.06) rotate(90)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#878787" />
          <stop offset=".07" stop-color="gray" />
          <stop offset=".18" stop-color="#6d6d6c" />
          <stop offset=".23" stop-color="#626261" />
          <stop offset=".25" stop-color="#5f5f5e" />
          <stop offset=".63" stop-color="#313232" />
          <stop offset=".82" stop-color="#1f2121" />
        </radialGradient>
        <linearGradient
          id="linear-gradient-122"
          x1="3104.74"
          y1="916.29"
          x2="3104.97"
          y2="916.52"
          gradientTransform="translate(1324.58 -2835.06) rotate(90)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#1f2121" />
          <stop offset="1" stop-color="#d6d6d6" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-123"
          x1="3104.14"
          y1="911.42"
          x2="3105.39"
          y2="911.42"
          gradientTransform="translate(1324.58 -2835.06) rotate(90)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#cf2b29" />
          <stop offset=".99" stop-color="#e73432" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-124"
          x1="5197.78"
          y1="-37.32"
          x2="5198.47"
          y2="-38.01"
          gradientTransform="translate(5611.28 232.05) rotate(-180)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#e73432" />
          <stop offset="1" stop-color="#cf2b29" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-125"
          x1="400.81"
          y1="275.85"
          x2="407.38"
          y2="278.37"
          gradientTransform="translate(314.3 -204.58) rotate(45)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#f1f1ea" />
          <stop offset=".03" stop-color="#e9e9e2" />
          <stop offset=".06" stop-color="#d5d5cf" />
          <stop offset=".1" stop-color="#b3b3af" />
          <stop offset=".14" stop-color="#858583" />
          <stop offset=".15" stop-color="#7f7f7d" />
          <stop offset=".18" stop-color="#888886" />
          <stop offset=".23" stop-color="#a0a09f" />
          <stop offset=".3" stop-color="#c8c8c7" />
          <stop offset=".37" stop-color="#fff" />
          <stop offset=".38" stop-color="#fff" />
          <stop offset=".43" stop-color="#fff" />
          <stop offset=".45" stop-color="#ebebeb" />
          <stop offset=".47" stop-color="#dbdada" />
          <stop offset=".49" stop-color="#cfcece" />
          <stop offset=".52" stop-color="#c8c7c7" />
          <stop offset=".62" stop-color="#c7c6c6" />
          <stop offset=".81" stop-color="#efeeee" />
          <stop offset=".81" stop-color="#eeeded" />
          <stop offset=".84" stop-color="#c0bfbf" />
          <stop offset=".88" stop-color="#9a9a99" />
          <stop offset=".91" stop-color="#7d7c7c" />
          <stop offset=".94" stop-color="#676766" />
          <stop offset=".97" stop-color="#5b5b5a" />
          <stop offset="1" stop-color="#575756" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-126"
          x1="3046.66"
          y1="-2357.14"
          x2="3053.23"
          y2="-2354.61"
          gradientTransform="translate(4226.59 -228.47) rotate(135) scale(1 -1)"
          xlink:href="#linear-gradient-125"
        />
        <linearGradient
          id="linear-gradient-127"
          x1="393.12"
          y1="269.97"
          x2="400.11"
          y2="269.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#242424" />
          <stop offset="0" stop-color="#474748" />
          <stop offset=".01" stop-color="#676767" />
          <stop offset=".02" stop-color="#818181" />
          <stop offset=".03" stop-color="#959595" />
          <stop offset=".04" stop-color="#a3a3a4" />
          <stop offset=".05" stop-color="#ababac" />
          <stop offset=".06" stop-color="#aeaeaf" />
          <stop offset=".13" stop-color="#99999a" />
          <stop offset=".25" stop-color="#797979" />
          <stop offset=".36" stop-color="#626262" />
          <stop offset=".47" stop-color="#535353" />
          <stop offset=".56" stop-color="#4f4f4f" />
          <stop offset=".7" stop-color="#4b4b4b" />
          <stop offset=".81" stop-color="#414141" />
          <stop offset=".91" stop-color="#303030" />
          <stop offset="1" stop-color="#1c1c1c" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-128"
          x1="393.89"
          y1="270.04"
          x2="399.25"
          y2="270.04"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#linear-gradient-48"
        />
        <linearGradient
          id="linear-gradient-129"
          x1="396.87"
          y1="267.42"
          x2="399.14"
          y2="265.14"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-130"
          x1="396.87"
          y1="274.28"
          x2="399.14"
          y2="272"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-131"
          x1="400.41"
          y1="271.33"
          x2="403.64"
          y2="268.09"
          xlink:href="#linear-gradient-21"
        />
        <radialGradient
          id="radial-gradient-7"
          cy="859.2"
          fy="859.2"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#radial-gradient"
        />
        <linearGradient
          id="linear-gradient-132"
          x1="281.86"
          y1="849.38"
          x2="283.42"
          y2="850.94"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-133"
          x1="277.37"
          y1="846.34"
          x2="278.93"
          y2="847.91"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-134"
          x1="272.03"
          y1="845.39"
          x2="273.6"
          y2="846.96"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-135"
          x1="266.77"
          y1="846.7"
          x2="268.33"
          y2="848.26"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-136"
          x1="262.49"
          y1="850.03"
          x2="264.06"
          y2="851.59"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-137"
          x1="259.94"
          y1="854.81"
          x2="261.51"
          y2="856.37"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-138"
          x1="259.55"
          y1="860.22"
          x2="261.12"
          y2="861.78"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-139"
          x1="261.4"
          y1="865.31"
          x2="262.97"
          y2="866.88"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-140"
          x1="265.16"
          y1="869.22"
          x2="266.73"
          y2="870.78"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-141"
          x1="270.18"
          y1="871.26"
          x2="271.75"
          y2="872.82"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-142"
          x1="275.6"
          y1="871.08"
          x2="277.17"
          y2="872.64"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-143"
          x1="280.48"
          y1="868.71"
          x2="282.04"
          y2="870.27"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-144"
          x1="283.97"
          y1="864.56"
          x2="285.53"
          y2="866.12"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-145"
          x1="285.47"
          y1="859.35"
          x2="287.04"
          y2="860.92"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-146"
          x1="284.72"
          y1="853.98"
          x2="286.29"
          y2="855.55"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-147"
          y1="832.08"
          y2="833.85"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-16"
        />
        <linearGradient
          id="linear-gradient-148"
          x1="486.05"
          y1="597.29"
          x2="491.73"
          y2="597.29"
          gradientTransform="translate(-212.79 647.86) scale(1 -1)"
          xlink:href="#linear-gradient-17"
        />
        <linearGradient
          id="linear-gradient-149"
          x1="216.37"
          y1="829.37"
          x2="216.37"
          y2="817.79"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-18"
        />
        <linearGradient
          id="linear-gradient-150"
          x1="3135.66"
          y1="-1588.93"
          x2="3135.66"
          y2="-1599.58"
          gradientTransform="translate(3355.78 1668.36) rotate(-180) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-151"
          x1="407.74"
          y1="763.69"
          x2="417.67"
          y2="757.48"
          gradientTransform="translate(430.05 1006.82) rotate(-29.63) scale(1 -1)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-152"
          x1="355.66"
          y1="821.5"
          x2="355.66"
          y2="814.95"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-153"
          x1="352.81"
          y1="822"
          x2="352.81"
          y2="814.45"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-22"
        />
        <linearGradient
          id="linear-gradient-154"
          x1="420.97"
          y1="768.07"
          x2="420.97"
          y2="763.89"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-155"
          x1="420.46"
          y1="768.43"
          x2="420.46"
          y2="763.53"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-156"
          x1="389.73"
          y1="824.04"
          x2="389.73"
          y2="814.57"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-157"
          x1="377.04"
          y1="817.79"
          x2="377.04"
          y2="816.79"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-158"
          x1="377.04"
          y1="819.56"
          x2="377.04"
          y2="818.55"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-159"
          x1="377.04"
          y1="810.75"
          x2="377.04"
          y2="809.84"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-160"
          x1="377.04"
          y1="812.51"
          x2="377.04"
          y2="811.51"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-161"
          x1="377.04"
          y1="822"
          x2="377.04"
          y2="820.31"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-162"
          x1="377.04"
          y1="816.03"
          x2="377.04"
          y2="815.03"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-163"
          x1="377.04"
          y1="814.27"
          x2="377.04"
          y2="813.27"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-164"
          x1="377.04"
          y1="835.4"
          x2="377.04"
          y2="834.28"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-165"
          x1="377.04"
          y1="833.44"
          x2="377.04"
          y2="832.32"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-166"
          x1="377.04"
          y1="843.14"
          x2="377.04"
          y2="842.13"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-167"
          x1="377.04"
          y1="841.28"
          x2="377.04"
          y2="840.17"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-168"
          x1="377.04"
          y1="831.48"
          x2="377.04"
          y2="829.6"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-169"
          x1="377.04"
          y1="837.36"
          x2="377.04"
          y2="836.25"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-170"
          x1="377.04"
          y1="839.32"
          x2="377.04"
          y2="838.21"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-171"
          x1="377.04"
          y1="829.07"
          x2="377.04"
          y2="828.07"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-172"
          x1="377.04"
          y1="823.79"
          x2="377.04"
          y2="822.79"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-173"
          x1="377.04"
          y1="827.31"
          x2="377.04"
          y2="826.31"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-174"
          x1="377.04"
          y1="825.55"
          x2="377.04"
          y2="824.55"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-175"
          x1="372.53"
          y1="833.83"
          x2="373.45"
          y2="834.75"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-176"
          x1="372.53"
          y1="837.58"
          x2="373.45"
          y2="838.5"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-177"
          x1="379.57"
          y1="833.83"
          x2="380.49"
          y2="834.75"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-178"
          x1="379.57"
          y1="837.58"
          x2="380.49"
          y2="838.5"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-179"
          x1="376.51"
          y1="838.95"
          x2="376.51"
          y2="833.39"
          gradientTransform="translate(1212.68 442.57) rotate(-90) scale(1 -1)"
          xlink:href="#linear-gradient-48"
        />
        <linearGradient
          id="linear-gradient-180"
          x1="367.63"
          y1="806.32"
          x2="370.6"
          y2="806.32"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-181"
          y1="809.84"
          y2="806.09"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-50"
        />
        <linearGradient
          id="linear-gradient-182"
          y1="806.95"
          y2="806.95"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-51"
        />
        <linearGradient
          id="linear-gradient-183"
          x1="383.48"
          y1="806.32"
          x2="386.45"
          y2="806.32"
          gradientTransform="translate(769.94 -710.4) rotate(-180) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-184"
          x1="384.97"
          y1="809.84"
          x2="384.97"
          y2="806.09"
          gradientTransform="translate(769.94 -713.7) rotate(-180) scale(1 -1)"
          xlink:href="#linear-gradient-50"
        />
        <linearGradient
          id="linear-gradient-185"
          x1="377.34"
          y1="806.95"
          x2="379.05"
          y2="806.95"
          gradientTransform="translate(756.39 -711.68) rotate(-180) scale(1 -1)"
          xlink:href="#linear-gradient-51"
        />
        <linearGradient
          id="linear-gradient-186"
          y1="863.77"
          y2="841.8"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-55"
        />
        <linearGradient
          id="linear-gradient-187"
          x1="344.47"
          y1="853.85"
          x2="346.67"
          y2="856.06"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-188"
          x1="345.57"
          y1="856.13"
          x2="345.57"
          y2="853.77"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-57"
        />
        <linearGradient
          id="linear-gradient-189"
          x1="365.69"
          y1="859.8"
          x2="367.9"
          y2="862"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-190"
          x1="366.8"
          y1="862.08"
          x2="366.8"
          y2="859.72"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-57"
        />
        <linearGradient
          id="linear-gradient-191"
          x1="344.47"
          y1="849.51"
          x2="346.67"
          y2="851.72"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-192"
          x1="345.57"
          y1="851.8"
          x2="345.57"
          y2="849.43"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-57"
        />
        <linearGradient
          id="linear-gradient-193"
          x1="366.8"
          y1="852.07"
          x2="366.8"
          y2="844.58"
          gradientTransform="translate(-543.27 -107.24) rotate(76.66) scale(1 -1)"
          xlink:href="#linear-gradient-62"
        />
        <linearGradient
          id="linear-gradient-194"
          x1="373.51"
          y1="775.36"
          x2="385.22"
          y2="773.92"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-195"
          x1="217.4"
          y1="873.25"
          x2="217.4"
          y2="867.56"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-196"
          x1="274.73"
          y1="877.49"
          x2="274.73"
          y2="863.32"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-197"
          x1="399.51"
          y1="740.15"
          x2="399.51"
          y2="725.62"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-66"
        />
        <radialGradient
          id="radial-gradient-8"
          cx="461.06"
          cy="859.2"
          fx="461.06"
          fy="859.2"
          r="42.89"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#radial-gradient"
        />
        <linearGradient
          id="linear-gradient-198"
          x1="466.64"
          y1="852.63"
          x2="467.69"
          y2="853.67"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-199"
          x1="463.64"
          y1="850.59"
          x2="464.69"
          y2="851.64"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-200"
          x1="460.06"
          y1="849.96"
          x2="461.11"
          y2="851"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-201"
          x1="456.54"
          y1="850.83"
          x2="457.59"
          y2="851.88"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-202"
          x1="453.68"
          y1="853.06"
          x2="454.72"
          y2="854.11"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-203"
          x1="451.97"
          y1="856.26"
          x2="453.01"
          y2="857.31"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-204"
          x1="451.71"
          y1="859.88"
          x2="452.76"
          y2="860.93"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-205"
          x1="452.94"
          y1="863.3"
          x2="453.99"
          y2="864.34"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-206"
          x1="455.46"
          y1="865.91"
          x2="456.51"
          y2="866.96"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-207"
          x1="458.83"
          y1="867.28"
          x2="459.87"
          y2="868.32"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-208"
          x1="462.45"
          y1="867.15"
          x2="463.5"
          y2="868.2"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-209"
          x1="465.72"
          y1="865.57"
          x2="466.77"
          y2="866.62"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-210"
          x1="468.06"
          y1="862.79"
          x2="469.11"
          y2="863.84"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-211"
          x1="469.06"
          y1="859.3"
          x2="470.11"
          y2="860.35"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-212"
          x1="468.56"
          y1="855.71"
          x2="469.61"
          y2="856.75"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-213"
          x1="438.25"
          y1="823.1"
          x2="443.73"
          y2="820.19"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-214"
          x1="421.15"
          y1="790.67"
          x2="426.52"
          y2="787.82"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-83"
        />
        <linearGradient
          id="linear-gradient-215"
          x1="420.37"
          y1="799.52"
          x2="420.37"
          y2="788.87"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-216"
          x1="434.24"
          y1="768.12"
          x2="434.24"
          y2="760.94"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-85"
        />
        <linearGradient
          id="linear-gradient-217"
          x1="428.99"
          y1="785.81"
          x2="428.99"
          y2="760.44"
          gradientTransform="translate(0 902.23) scale(1 -1)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-218"
          x1="46.18"
          y1="255.14"
          x2="46.18"
          y2="233.31"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-55"
        />
        <radialGradient
          id="radial-gradient-9"
          cx="44.08"
          cy="262.21"
          fx="44.08"
          fy="262.21"
          r="6.95"
          gradientTransform="translate(587.68 61.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#1c1c1c" />
          <stop offset=".02" stop-color="#202020" />
          <stop offset=".5" stop-color="#9d9d9d" />
          <stop offset=".71" stop-color="#cfcfcf" />
          <stop offset=".75" stop-color="#bcbcbc" />
          <stop offset=".84" stop-color="#8b8b8b" />
          <stop offset=".96" stop-color="#3e3e3e" />
          <stop offset="1" stop-color="#242424" />
        </radialGradient>
        <linearGradient
          id="linear-gradient-219"
          x1="244.95"
          y1="730.35"
          x2="250.03"
          y2="730.35"
          gradientTransform="translate(562.83 -468.95) rotate(13.15)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-220"
          x1="51.62"
          y1="153.02"
          x2="68.59"
          y2="153.02"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-20"
        />
        <linearGradient
          id="linear-gradient-221"
          x1="40.26"
          y1="186.57"
          x2="40.26"
          y2="184.34"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-222"
          x1="4568.44"
          y1="186.57"
          x2="4568.44"
          y2="184.34"
          gradientTransform="translate(-3900.9 432.89) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-223"
          x1="60.16"
          y1="201.5"
          x2="60.16"
          y2="194.94"
          gradientTransform="translate(587.68 61.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#1c1c1c" />
          <stop offset=".17" stop-color="#262626" />
          <stop offset=".42" stop-color="#303030" />
          <stop offset=".74" stop-color="#343434" />
          <stop offset=".77" stop-color="#383838" />
          <stop offset=".81" stop-color="#474747" />
          <stop offset=".85" stop-color="#5e5e5e" />
          <stop offset=".89" stop-color="#7f7f80" />
          <stop offset=".93" stop-color="#a9a9aa" />
          <stop offset=".94" stop-color="#aeaeaf" />
          <stop offset=".95" stop-color="#ababac" />
          <stop offset=".96" stop-color="#a3a3a4" />
          <stop offset=".97" stop-color="#959595" />
          <stop offset=".98" stop-color="#818181" />
          <stop offset=".99" stop-color="#676767" />
          <stop offset=".99" stop-color="#474748" />
          <stop offset="1" stop-color="#242424" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-224"
          x1="60.06"
          y1="202.12"
          x2="60.06"
          y2="201.21"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-26"
        />
        <linearGradient
          id="linear-gradient-225"
          x1="58.58"
          y1="197.69"
          x2="61.55"
          y2="197.69"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-226"
          x1="60.06"
          y1="201.21"
          x2="60.06"
          y2="197.46"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-50"
        />
        <linearGradient
          id="linear-gradient-227"
          x1="59.57"
          y1="252.61"
          x2="59.57"
          y2="248.32"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-228"
          x1="4594.69"
          y1="-938.63"
          x2="4600.06"
          y2="-941.48"
          gradientTransform="translate(5166.88 -1074.6) rotate(152.15) scale(1 -1)"
          xlink:href="#linear-gradient-83"
        />
        <linearGradient
          id="linear-gradient-229"
          x1="4570.18"
          y1="191.64"
          x2="4576.21"
          y2="191.64"
          gradientTransform="translate(5235.98 61.98) rotate(-180) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-230"
          x1="4570.17"
          y1="234.97"
          x2="4576.2"
          y2="234.97"
          gradientTransform="translate(5235.98 61.98) rotate(-180) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-231"
          x1="4573.18"
          y1="253.24"
          x2="4573.18"
          y2="247.81"
          gradientTransform="translate(-3910.38 563.03) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-232"
          x1="4571.57"
          y1="-926.41"
          x2="4576.93"
          y2="-929.27"
          gradientTransform="translate(5110.63 -1074.6) rotate(152.15) scale(1 -1)"
          xlink:href="#linear-gradient-83"
        />
        <linearGradient
          id="linear-gradient-233"
          x1="4544.03"
          y1="191.64"
          x2="4550.06"
          y2="191.64"
          gradientTransform="translate(5179.73 61.98) rotate(-180) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-234"
          x1="4544.02"
          y1="234.97"
          x2="4550.05"
          y2="234.97"
          gradientTransform="translate(5179.73 61.98) rotate(-180) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-235"
          x1="4547.03"
          y1="253.24"
          x2="4547.03"
          y2="247.81"
          gradientTransform="translate(-3914.33 563.03) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-236"
          x1="52.45"
          y1="250.27"
          x2="67.67"
          y2="250.27"
          gradientTransform="translate(587.68 61.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".03" stop-color="#1b1b1b" />
          <stop offset=".11" stop-color="#212121" />
          <stop offset=".22" stop-color="#333" />
          <stop offset=".35" stop-color="#515151" />
          <stop offset=".54" stop-color="#464545" />
          <stop offset=".69" stop-color="#515151" />
          <stop offset=".84" stop-color="#343434" />
          <stop offset=".95" stop-color="#1b1b1b" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-237"
          x1="46.33"
          y1="157.28"
          x2="51.08"
          y2="157.28"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-57"
        />
        <linearGradient
          id="linear-gradient-238"
          x1="46.69"
          y1="157.28"
          x2="50.71"
          y2="157.28"
          gradientTransform="translate(587.68 61.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#242424" />
          <stop offset=".1" stop-color="#4b4b4b" />
          <stop offset=".35" stop-color="#ababab" />
          <stop offset=".53" stop-color="#e7e7e7" />
          <stop offset=".61" stop-color="#fff" />
          <stop offset=".76" stop-color="#a9a9a9" />
          <stop offset="1" stop-color="#161617" />
        </linearGradient>
        <radialGradient
          id="radial-gradient-10"
          cx="48.7"
          cy="157.28"
          fx="48.7"
          fy="157.28"
          r="2.01"
          gradientTransform="translate(587.68 61.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#fff" />
          <stop offset=".26" stop-color="#fcfcfc" />
          <stop offset=".43" stop-color="#f3f3f3" />
          <stop offset=".56" stop-color="#e5e5e5" />
          <stop offset=".68" stop-color="#d1d1d0" />
          <stop offset=".79" stop-color="#b6b6b6" />
          <stop offset=".9" stop-color="#969695" />
          <stop offset=".99" stop-color="#70706f" />
          <stop offset="1" stop-color="#6d6d6c" />
        </radialGradient>

        <linearGradient
          id="linear-gradient-239"
          x1="4574.5"
          y1="157.28"
          x2="4579.25"
          y2="157.28"
          gradientTransform="translate(5235.98 61.98) rotate(-180) scale(1 -1)"
          xlink:href="#linear-gradient-57"
        />
        <linearGradient
          id="linear-gradient-240"
          x1="4574.87"
          x2="4578.89"
          gradientTransform="translate(5235.98 61.98) rotate(-180) scale(1 -1)"
          xlink:href="#linear-gradient-238"
        />
        <radialGradient
          id="radial-gradient-11"
          cx="4576.88"
          fx="4576.88"
          r="2.01"
          gradientTransform="translate(5235.98 61.98) rotate(-180) scale(1 -1)"
          xlink:href="#radial-gradient-10"
        />

        <linearGradient
          id="linear-gradient-241"
          x1="49.29"
          y1="169.13"
          x2="72.74"
          y2="159.07"
          gradientTransform="translate(587.68 61.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#393938" />
          <stop offset=".04" stop-color="#40403f" />
          <stop offset=".08" stop-color="#545453" />
          <stop offset=".14" stop-color="#767674" />
          <stop offset=".15" stop-color="#7f7f7d" />
          <stop offset=".18" stop-color="#888886" />
          <stop offset=".23" stop-color="#a0a09f" />
          <stop offset=".3" stop-color="#c8c8c7" />
          <stop offset=".37" stop-color="#fff" />
          <stop offset=".38" stop-color="#fff" />
          <stop offset=".43" stop-color="#fff" />
          <stop offset=".45" stop-color="#ebebeb" />
          <stop offset=".47" stop-color="#dbdada" />
          <stop offset=".49" stop-color="#cfcece" />
          <stop offset=".52" stop-color="#c8c7c7" />
          <stop offset=".62" stop-color="#c7c6c6" />
          <stop offset=".68" stop-color="#cbcaca" />
          <stop offset=".74" stop-color="#d7d6d6" />
          <stop offset=".81" stop-color="#edecec" />
          <stop offset=".81" stop-color="#efeeee" />
          <stop offset=".81" stop-color="#eeeded" />
          <stop offset=".84" stop-color="#c0bfbf" />
          <stop offset=".88" stop-color="#9a9a99" />
          <stop offset=".91" stop-color="#7d7c7c" />
          <stop offset=".94" stop-color="#676766" />
          <stop offset=".97" stop-color="#5b5b5a" />
          <stop offset="1" stop-color="#575756" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-242"
          x1="49.06"
          y1="156.12"
          x2="71.06"
          y2="156.12"
          gradientTransform="translate(587.68 61.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#1c1c1c" />
          <stop offset=".03" stop-color="#454545" />
          <stop offset=".06" stop-color="#727171" />
          <stop offset=".09" stop-color="#989797" />
          <stop offset=".12" stop-color="#b7b6b6" />
          <stop offset=".15" stop-color="#cfcece" />
          <stop offset=".19" stop-color="#e0dfdf" />
          <stop offset=".23" stop-color="#eae9e9" />
          <stop offset=".27" stop-color="#eeeded" />
          <stop offset=".38" stop-color="#c5c4c4" />
          <stop offset=".61" stop-color="#5e5d5d" />
          <stop offset=".63" stop-color="#555454" />
          <stop offset=".65" stop-color="#605f5f" />
          <stop offset=".73" stop-color="#a4a3a3" />
          <stop offset=".79" stop-color="#d5d5d5" />
          <stop offset=".85" stop-color="#f3f3f3" />
          <stop offset=".88" stop-color="#fff" />
          <stop offset=".91" stop-color="#fcfcfc" />
          <stop offset=".92" stop-color="#f4f4f4" />
          <stop offset=".94" stop-color="#e5e5e5" />
          <stop offset=".95" stop-color="#d1d1d1" />
          <stop offset=".96" stop-color="#b7b7b7" />
          <stop offset=".97" stop-color="#979797" />
          <stop offset=".98" stop-color="#717171" />
          <stop offset=".99" stop-color="#464646" />
          <stop offset="1" stop-color="#242424" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-243"
          x1="-540.67"
          y1="254.76"
          x2="-540.67"
          y2="232.93"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-55"
        />
        <linearGradient
          id="linear-gradient-244"
          x1="-222.34"
          y1="1217.43"
          x2="-217.27"
          y2="1217.43"
          gradientTransform="translate(562.83 1433.72) rotate(-13.15) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
        <radialGradient
          id="radial-gradient-12"
          cx="-510.46"
          cy="261.83"
          fx="-510.46"
          fy="261.83"
          xlink:href="#radial-gradient-9"
        />
        <linearGradient
          id="linear-gradient-245"
          x1="-546.53"
          y1="186.18"
          x2="-546.53"
          y2="183.95"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-246"
          x1="5155.23"
          y1="186.18"
          x2="5155.23"
          y2="183.95"
          gradientTransform="translate(-5074.48 432.12) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />

        <linearGradient
          id="linear-gradient-247"
          x1="-527.22"
          y1="252.22"
          x2="-527.22"
          y2="247.93"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-248"
          x1="5102.02"
          y1="127.4"
          x2="5108.05"
          y2="127.4"
          gradientTransform="translate(5013.95 -991.14) rotate(166.82) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-249"
          x1="5105.03"
          y1="145.66"
          x2="5105.03"
          y2="140.24"
          gradientTransform="translate(-5029.03 455.07) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-250"
          x1="5160.3"
          y1="354.9"
          x2="5166.33"
          y2="354.9"
          gradientTransform="translate(5152.18 1162.42) rotate(-166.44) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-251"
          x1="5163.31"
          y1="373.17"
          x2="5163.31"
          y2="367.75"
          gradientTransform="translate(-5117.41 682.58) scale(1 -1)"
          xlink:href="#linear-gradient-21"
        />
        <linearGradient
          id="linear-gradient-252"
          x1="-534.34"
          y1="249.89"
          x2="-519.13"
          y2="249.89"
          xlink:href="#linear-gradient-236"
        />
        <linearGradient
          id="linear-gradient-253"
          x1="-534.53"
          y1="220.61"
          x2="-534.53"
          y2="218.38"
          gradientTransform="translate(587.68 61.98)"
          xlink:href="#linear-gradient-19"
        />
        <linearGradient
          id="linear-gradient-254"
          x1="5167.23"
          y1="220.61"
          x2="5167.23"
          y2="218.38"
          gradientTransform="translate(-5098.48 500.97) scale(1 -1)"
          xlink:href="#linear-gradient-19"
        />
      </defs>
      <g class="cls-999">
        <g id="Front">
          <FrontLeftHandlebar
            :severityClass="frontLeftHandlebarClass"
            v-on:changeSeverity="changeFrontDamageSeverity"
          ></FrontLeftHandlebar>
          <FrontLeftRearViewMirror
            :severityClass="frontLeftRearViewMirrorClass"
            v-on:changeSeverity="changeFrontDamageSeverity"
          ></FrontLeftRearViewMirror>
          <FrontRightHandlebar
            :severityClass="frontRightHandlebarClass"
            v-on:changeSeverity="changeFrontDamageSeverity"
          ></FrontRightHandlebar>
          <FrontRightRearViewMirror
            :severityClass="frontRightRearViewMirrorClass"
            v-on:changeSeverity="changeFrontDamageSeverity"
          ></FrontRightRearViewMirror>
          <FrontMainBody
            :severityClass="frontMainBodyClass"
            v-on:changeSeverity="changeFrontDamageSeverity"
          ></FrontMainBody>
          <FrontRightIndicator
            :severityClass="frontRightIndicatorClass"
            v-on:changeSeverity="changeFrontDamageSeverity"
          ></FrontRightIndicator>
          <FrontLeftIndicator
            :severityClass="frontLeftIndicatorClass"
            v-on:changeSeverity="changeFrontDamageSeverity"
          ></FrontLeftIndicator>
          <FrontWheel
            :severityClass="frontWheelClass"
            v-on:changeSeverity="changeFrontDamageSeverity"
          ></FrontWheel>
          <FrontHeadLamp
            :severityClass="frontHeadLampClass"
            v-on:changeSeverity="changeFrontDamageSeverity"
          ></FrontHeadLamp>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import FrontLeftHandlebar from './Damage/Front/FrontLeftHandlebar';
import FrontLeftRearViewMirror from './Damage/Front/FrontLeftRearViewMirror';
import FrontRightHandlebar from './Damage/Front/FrontRightHandlebar';
import FrontRightRearViewMirror from './Damage/Front/FrontRightRearViewMirror';
import FrontMainBody from './Damage/Front/FrontMainBody';
import FrontRightIndicator from './Damage/Front/FrontRightIndicator';
import FrontLeftIndicator from './Damage/Front/FrontLeftIndicator';
import FrontWheel from './Damage/Front/FrontWheel';
import FrontHeadLamp from './Damage/Front/FrontHeadLamp';
export default {
  components: {
    FrontLeftHandlebar,
    FrontLeftRearViewMirror,
    FrontRightHandlebar,
    FrontRightRearViewMirror,
    FrontMainBody,
    FrontRightIndicator,
    FrontLeftIndicator,
    FrontWheel,
    FrontHeadLamp
  },
  props: {
    frontHeadLamp: [Number, String],
    frontLeftHandlebar: [Number, String],
    frontLeftIndicator: [Number, String],
    frontLeftRearViewMirror: [Number, String],
    frontRightHandlebar: [Number, String],
    frontRightRearViewMirror: [Number, String],
    frontMainBody: [Number, String],
    frontRightIndicator: [Number, String],
    frontWheel: [Number, String]
  },
  watch: {
    frontHeadLamp: {
      handler(value) {
        if (value) {
          this.front.frontHeadLamp = value;
        }
      },
      immediate: true,
      deep: true
    },
    frontLeftHandlebar: {
      handler(value) {
        if (value) {
          this.front.frontLeftHandlebar = value;
        }
      },
      immediate: true,
      deep: true
    },
    frontLeftIndicator: {
      handler(value) {
        if (value) {
          this.front.frontLeftIndicator = value;
        }
      },
      immediate: true,
      deep: true
    },
    frontLeftRearViewMirror: {
      handler(value) {
        if (value) {
          this.front.frontLeftRearViewMirror = value;
        }
      },
      immediate: true,
      deep: true
    },
    frontRightHandlebar: {
      handler(value) {
        if (value) {
          this.front.frontRightHandlebar = value;
        }
      },
      immediate: true,
      deep: true
    },
    frontRightRearViewMirror: {
      handler(value) {
        if (value) {
          this.front.frontRightRearViewMirror = value;
        }
      },
      immediate: true,
      deep: true
    },
    frontMainBody: {
      handler(value) {
        if (value) {
          this.front.frontMainBody = value;
        }
      },
      immediate: true,
      deep: true
    },
    frontRightIndicator: {
      handler(value) {
        if (value) {
          this.front.frontRightIndicator = value;
        }
      },
      immediate: true,
      deep: true
    },
    frontWheel: {
      handler(value) {
        if (value) {
          this.front.frontWheel = value;
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      front: {
        frontHeadLamp: 0,
        frontLeftHandlebar: 0,
        frontLeftIndicator: 0,
        frontLeftRearViewMirror: 0,
        frontRightHandlebar: 0,
        frontRightRearViewMirror: 0,
        frontMainBody: 0,
        frontRightIndicator: 0,
        frontWheel: 0
      }
    };
  },
  mounted() {
    this.$root.$on('rearDamageUpdated', rear => {
      this.front.frontLeftRearViewMirror = rear.rearLeftRearViewMirror;
      this.front.frontRightRearViewMirror = rear.rearRightRearViewMirror;
      this.front.frontLeftHandlebar = rear.rearLeftHandlebar;
      this.front.frontRightHandlebar = rear.rearRightHandlebar;
      this.front.frontLeftIndicator = rear.rearFrontRightIndicator;
      this.front.frontRightIndicator = rear.rearFrontLeftIndicator;
      this.$emit('frontDamageUpdated', this.front);
    });
  },
  computed: {
    frontHeadLampClass() {
      return this.getSeverityClass(this.front.frontHeadLamp);
    },
    frontLeftRearViewMirrorClass() {
      return this.getSeverityClass(this.front.frontLeftRearViewMirror);
    },
    frontLeftHandlebarClass() {
      return this.getSeverityClass(this.front.frontLeftHandlebar);
    },
    frontLeftIndicatorClass() {
      return this.getSeverityClass(this.front.frontLeftIndicator);
    },
    frontRightHandlebarClass() {
      return this.getSeverityClass(this.front.frontRightHandlebar);
    },
    frontRightRearViewMirrorClass() {
      return this.getSeverityClass(this.front.frontRightRearViewMirror);
    },
    frontMainBodyClass() {
      return this.getSeverityClass(this.front.frontMainBody);
    },
    frontRightIndicatorClass() {
      return this.getSeverityClass(this.front.frontRightIndicator);
    },
    frontWheelClass() {
      return this.getSeverityClass(this.front.frontWheel);
    }
  },
  methods: {
    changeFrontDamageSeverity(section) {
      if (this.front[section] == 3) {
        this.front[section] = 0;
      } else {
        this.front[section] = this.front[section] + 1;
      }
      this.$emit('frontDamageUpdated', this.front);
      this.$root.$emit('frontDamageUpdated', this.front);
    },
    getSeverityClass(section) {
      if (section == 0) {
        return;
      }

      if (section == 1) {
        return 'minor-damage';
      }

      if (section == 2) {
        return 'major-damage';
      }

      if (section == 3) {
        return 'severe-damage';
      }
    }
  }
};
</script>
